//# sourceMappingURL=llm_capacity.mjs.map
/// <reference types="./llm_capacity.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $llm_capacity from "../../../data_types/data/llm_capacity.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $llm_usage from "../../data/llm_usage.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

function dispatch_rate_limits(dispatch, rate_limits) {
  let _pipe = new $msg.ApiReturnedRateLimits(rate_limits);
  let _pipe$1 = new $msg.LlmCapacity(_pipe);
  dispatch(_pipe$1);
  return undefined;
}

export function fetch_rate_limits() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch_rate_limits(dispatch, new $remote.Loading());
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "llm-rate-limits"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($llm_capacity.rate_limit_decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (rate_limits) => {
              return dispatch_rate_limits(
                dispatch,
                new $remote.Loaded(rate_limits),
              );
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              return dispatch_rate_limits(
                dispatch,
                new $remote.Errored($string.inspect(error)),
              );
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Pings every deployment, one after the other: takes a minute or two.
 */
export function refresh_rate_limits() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch_rate_limits(dispatch, new $remote.Loading());
          let _pipe = $ask.to(
            new $ask.Nabu(),
            toList(["admin", "llm-rate-limits", "refresh"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($llm_capacity.rate_limit_decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (rate_limits) => {
              return dispatch_rate_limits(
                dispatch,
                new $remote.Loaded(rate_limits),
              );
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let error$1 = $string.inspect(error);
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Refreshing the rate limits failed: " + error$1,
              );
              dispatch(_pipe$5);
              return dispatch_rate_limits(
                dispatch,
                new $remote.Errored(error$1),
              );
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

function dispatch_activity(dispatch, months, activity) {
  let _pipe = new $msg.ApiReturnedOrganizationsActivity(months, activity);
  let _pipe$1 = new $msg.LlmCapacity(_pipe);
  dispatch(_pipe$1);
  return undefined;
}

export function fetch_organizations_activity(months) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch_activity(dispatch, months, new $remote.Loading());
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "organizations", "activity"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.query(_pipe$2, "months", $int.to_string(months));
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.list($llm_capacity.org_activity_decoder()),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (activity) => {
              let _pipe$5 = $list.map(
                activity,
                (org) => { return [org.org_id, org]; },
              );
              let _pipe$6 = $dict.from_list(_pipe$5);
              let _pipe$7 = new $remote.Loaded(_pipe$6);
              return ((_capture) => {
                return dispatch_activity(dispatch, months, _capture);
              })(_pipe$7);
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (error) => {
              return dispatch_activity(
                dispatch,
                months,
                new $remote.Errored($string.inspect(error)),
              );
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

function dispatch_usage(dispatch, environment, days, usage) {
  let _pipe = new $msg.ApiReturnedLlmUsage(environment, days, usage);
  let _pipe$1 = new $msg.LlmCapacity(_pipe);
  dispatch(_pipe$1);
  return undefined;
}

export function fetch_llm_usage(environment, days, refresh) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch_usage(dispatch, environment, days, new $remote.Loading());
          let _pipe = $ask.to(new $ask.Nabu(), toList(["admin", "llm-usage"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.query(_pipe$2, "environment", environment);
          let _pipe$4 = $ask.query(_pipe$3, "days", $int.to_string(days));
          let _pipe$5 = $ask.query(
            _pipe$4,
            "refresh",
            (() => {
              let _pipe$5 = $bool.to_string(refresh);
              return $string.lowercase(_pipe$5);
            })(),
          );
          let _pipe$6 = $ask.expect(_pipe$5, $llm_usage.usage_decoder());
          let _pipe$7 = $ask.on_success(
            _pipe$6,
            (usage) => {
              return dispatch_usage(
                dispatch,
                environment,
                days,
                new $remote.Loaded(usage),
              );
            },
          );
          let _pipe$8 = $ask.on_error(
            _pipe$7,
            (error) => {
              return dispatch_usage(
                dispatch,
                environment,
                days,
                new $remote.Errored($string.inspect(error)),
              );
            },
          );
          return $ask.run(_pipe$8);
        },
      );
    },
  );
}

function dispatch_usage_by_org(dispatch, environment, days, usage) {
  let _pipe = new $msg.ApiReturnedLlmUsageByOrg(environment, days, usage);
  let _pipe$1 = new $msg.LlmCapacity(_pipe);
  dispatch(_pipe$1);
  return undefined;
}

export function fetch_llm_usage_by_org(environment, days) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch_usage_by_org(
            dispatch,
            environment,
            days,
            new $remote.Loading(),
          );
          let _pipe = $ask.to(
            new $ask.Nabu(),
            toList(["admin", "llm-usage-by-org"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.query(_pipe$2, "environment", environment);
          let _pipe$4 = $ask.query(_pipe$3, "days", $int.to_string(days));
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.list($llm_usage.org_usage_decoder()),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (usage) => {
              let _pipe$6 = $list.map(
                usage,
                (org) => { return [org.org_id, org]; },
              );
              let _pipe$7 = $dict.from_list(_pipe$6);
              let _pipe$8 = new $remote.Loaded(_pipe$7);
              return ((_capture) => {
                return dispatch_usage_by_org(
                  dispatch,
                  environment,
                  days,
                  _capture,
                );
              })(_pipe$8);
            },
          );
          let _pipe$7 = $ask.on_error(
            _pipe$6,
            (error) => {
              return dispatch_usage_by_org(
                dispatch,
                environment,
                days,
                new $remote.Errored($string.inspect(error)),
              );
            },
          );
          return $ask.run(_pipe$7);
        },
      );
    },
  );
}
